/**
 * Copyright (c) HashiCorp, Inc.
 */

import { hash } from '@ember/helper';

import type { TOC } from '@ember/component/template-only';
import type { FilterConfig, ToggleArgs } from '../filter-bar';

export interface FilterBarGenericSignature {
  Args: {
    toggle?: (toggle: ToggleArgs) => void;
    softToggle?: (toggle: ToggleArgs) => void;
    config?: FilterConfig;
    localConfig?: FilterConfig;
    isChecked?: (
      localConfig: FilterConfig,
      name: string,
      value: unknown,
    ) => boolean;
    applyFilter?: (name: string) => void;
    clearPendingFilter?: (...args: unknown[]) => void;
  };
  Blocks: {
    default: [
      {
        toggle?: (toggle: ToggleArgs) => void;
        softToggle?: (toggle: ToggleArgs) => void;
        config?: FilterConfig;
        localConfig?: FilterConfig;
        applyFilter?: (name: string) => void;
      },
    ];
  };
  Element: HTMLDivElement;
}

const FilterBarGeneric: TOC<FilterBarGenericSignature> = <template>
  <div class="cut-filter-bar-generic">
    {{yield
      (hash
        toggle=@toggle
        softToggle=@softToggle
        applyFilter=@applyFilter
        config=@config
        localConfig=@localConfig
      )
    }}
  </div>
</template>;

export default FilterBarGeneric;
